import { useLocale } from '@pperform/pp-react-components/PpLocaleProvider';
import { MixedEvent, ParcelEvent } from '@pperform/pp-data-mappers';
import { SECTION_LINE_BORDER_RADIUS } from '@pperform/pp-constants/widgetConfigs';
import { useEffect } from 'preact/hooks';
import { useTranslation } from 'react-i18next';
import { usePTPConfigContext } from 'GlobalConfig.context';
import {
  EventSectionName,
  EventsContainer,
  Timeline,
} from './TrackingTimeline.styles';
import { groupEventsByDate } from './TrackingTimeline.service';
import { EventRow } from './components/EventRow';

interface TrackingTimelineProps {
  events: MixedEvent[] | ParcelEvent[];
}

export const TrackingTimeline = ({
  events,
}: TrackingTimelineProps): JSX.Element => {
  const { locale } = useLocale();
  const { t } = useTranslation();
  const {
    timezone,
    trackingDetailsBox: { eventDateFormat, sectionLineBorderRadius },
  } = usePTPConfigContext();

  const groupedEvents = groupEventsByDate(events, {
    locale,
    timezone,
    timeformat: eventDateFormat,
    translator: t,
  });

  const hasRounded =
    sectionLineBorderRadius === SECTION_LINE_BORDER_RADIUS.ROUND;

  return (
    <Timeline>
      {groupedEvents.map(([section, group]) => {
        return (
          <div key={section}>
            <EventSectionName data-testid="timeline-section-name">
              {section}
            </EventSectionName>
            <EventsContainer hasRounded={hasRounded}>
              {group.map((event) => {
                const isLatestEvent = events[0].id === event.id;
                return (
                  <EventRow
                    key={event.id}
                    event={event}
                    isLatestEvent={isLatestEvent}
                  />
                );
              })}
            </EventsContainer>
          </div>
        );
      })}
    </Timeline>
  );
};
